module.exports = __webpack_public_path__ + "static/media/mobile15.895b3eaf.png";